import { render } from "./EditWebCatalogGroups.vue?vue&type=template&id=48c24fd3"
import script from "./EditWebCatalogGroups.vue?vue&type=script&lang=js"
export * from "./EditWebCatalogGroups.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/WebOrders/EditWebCatalogGroups.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48c24fd3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48c24fd3', __exports__)) {
    api.reload('48c24fd3', __exports__)
  }
  
  module.hot.accept("./EditWebCatalogGroups.vue?vue&type=template&id=48c24fd3", () => {
    api.rerender('48c24fd3', render)
  })

}


export default __exports__